import { useFleetAlerts } from "./use-fleet-alerts";
import { useGpsAlertEvents } from "./useGpsAlertEvents";

export interface UnifiedAlertsData {
  // Alertas Fleet
  fleetAlerts: any[];
  fleetTotal: number;
  fleetActive: number;
  fleetCritical: number;
  
  // Alertas GPS
  gpsAlerts: any[];
  gpsTotal: number;
  gpsUnresolved: number;
  gpsHighPriority: number;
  
  // Loading states
  isLoadingFleet: boolean;
  isLoadingGps: boolean;
  isLoading: boolean;
}

export function useUnifiedAlerts(companyId?: string): UnifiedAlertsData {
  const fleetAlertsQuery = useFleetAlerts(companyId);
  const gpsAlertsQuery = useGpsAlertEvents(companyId);
  
  const fleetAlerts = fleetAlertsQuery.data || [];
  const gpsAlerts = gpsAlertsQuery.data || [];
  
  return {
    // Fleet
    fleetAlerts,
    fleetTotal: fleetAlerts.length,
    fleetActive: fleetAlerts.filter((a: any) => a.status === 'active').length,
    fleetCritical: fleetAlerts.filter((a: any) => a.priority === 'critical').length,
    
    // GPS
    gpsAlerts,
    gpsTotal: gpsAlerts.length,
    gpsUnresolved: gpsAlerts.filter((a: any) => !a.ack_at).length,
    gpsHighPriority: gpsAlerts.filter((a: any) => a.priority === 'high' && !a.ack_at).length,
    
    // Loading
    isLoadingFleet: fleetAlertsQuery.isLoading,
    isLoadingGps: gpsAlertsQuery.isLoading,
    isLoading: fleetAlertsQuery.isLoading || gpsAlertsQuery.isLoading,
  };
}
